import { HtmlBlock } from '@/cms/definitions/content-types';
import BuyInsuranceSettings from '../BuyInsuranceSettings';
import { exception } from '@/appinsights/logging/ApplicationInsightLog';

export class HouseSettings extends BuyInsuranceSettings {
	public changeCalcTitle: string;
	public changeCalcContent: string;
	public calculatorUrlOther: string;
	public calculatorUrl: string;
	public selectedRisksOther: Array<string>;
	public basePackageOther: number;
	public excessIdOther: number;

	public insuredValue: number; // holidayHouse default sum, being copied from product info

	public constructor(settingsBlock: HtmlBlock) {
		super(settingsBlock);
		this.loadHouseSettings();
	}

	/**
	 * load settings from CMS if present
	 */
	private loadHouseSettings() {
		try {
			let setting: string;
			const settingsArr = this.settingsBlock.markup.split('$');
			settingsArr.forEach((setting_) => {
				setting = setting_.toLowerCase().trim();
				if (setting.startsWith('changecalctitle=')) {
					this.changeCalcTitle = this.getSettingsValue(setting_);
				} else if (setting.startsWith('changecalccontent=')) {
					this.changeCalcContent = this.getSettingsValue(setting_);
				} else if (setting.startsWith('calculatorurlother=')) {
					this.calculatorUrlOther = this.getSettingsValue(setting_);
				} else if (setting.startsWith('calculatorurl=')) {
					this.calculatorUrl = this.getSettingsValue(setting_);
				} else if (setting.startsWith('selectedrisksother=')) {
					this.selectedRisksOther = this.getSettingsValue(setting_).split('¤');
				} else if (setting.startsWith('basepackageother=')) {
					this.basePackageOther = Number.parseInt(this.getSettingsValue(setting_));
				} else if (setting.startsWith('excessidother=')) {
					this.excessIdOther = Number.parseInt(this.getSettingsValue(setting_));
				}
			});
		} catch (e) {
			exception(e);
		}
	}
}
